import { findTextContrastingColor } from '../helpers.js';
import themeConfig from '../config';

export default {
  data: () => ({
    themeConfig,
  }),

  methods: {
    findTextContrastingClassColor(incColor) {
      let hexColor = '';
      if (incColor.includes('#')) {
        hexColor = incColor;
      } else {
        const [color, shade] = incColor.split('-');
        hexColor = shade ? themeConfig.colors[color][shade] : themeConfig.colors[color];
      }
      return findTextContrastingColor(hexColor);
    },

    getHexFromClassColor(incColor) {
      let hexColor = '';
      if (incColor.includes('#')) {
        hexColor = incColor;
      } else {
        const [color, shade] = incColor.split('-');
        hexColor = shade ? themeConfig.colors[color][shade] : themeConfig.colors[color];
      }
      return hexColor;
    },
  },
};